import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCan } from '@/features/admin-content/use-current-user';
import { StudentsAdmin } from '@/features/staff-workspace/StudentsAdmin';

export const Route = createFileRoute('/admin/students')({
  component: AdminStudentsPage,
});

function AdminStudentsPage() {
  const canPeople = useCan('users.admin');
  const canBilling = useCan('billing.admin');
  const allowed = canPeople && canBilling;
  if (!allowed) {
    return (
      <StaffOnly
        title="You cannot look up students"
        description="Only an admin can see a student's payments and access."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Students"
        description="Look a student up, give more days, or resend the verification email."
      />
      <StudentsAdmin />
    </div>
  );
}
